import React from 'react';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const scaleIn = keyframes`
  from {
    transform: scale(0.9);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: ${fadeIn} 0.2s ease;
`;

const ModalContainer = styled.div`
  background: #0B1122;
  padding: 1.5rem;
  border-radius: 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
  width: 360px;
  animation: ${scaleIn} 0.2s ease;
`;

const ModalTitle = styled.h4`
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
`;

const ModalDescription = styled.p`
  font-size: 0.875rem;
  color: #9ca3af;
  margin-bottom: 1.5rem;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 0.75rem;
`;

const ConfirmButton = styled.button`
  flex: 1;
  padding: 0.5rem;
  border-radius: 0.25rem;
  background: #ef4444;
  color: white;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.9;
  }
`;

const CancelButton = styled.button`
  flex: 1;
  padding: 0.5rem;
  border-radius: 0.25rem;
  background: rgba(255, 255, 255, 0.1);
  color: white;
  border: none;
  cursor: pointer;
  transition: background 0.2s;
  
  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }
`;

const DeleteConfirmModal = ({ store, onConfirm, onCancel }) => {
  if (!store) return null;

  return (
    <Overlay onClick={onCancel}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
          <ModalTitle>Delete Store</ModalTitle>
          <ModalDescription>
            This store will be hidden but not permanently removed.
          </ModalDescription>
          <ButtonGroup>
            <ConfirmButton onClick={onConfirm}>
              Confirm
            </ConfirmButton>
            <CancelButton onClick={onCancel}>
              Cancel
            </CancelButton>
          </ButtonGroup>
        </ModalContainer>
      </Overlay>
  );
};

export default DeleteConfirmModal;
